<template>
    <section>
        <List :title="table.title" :breadcumb="table.breadcumb" :dataTable="table.dataTable">
            <template v-slot:filter>
                <div v-if="!$route.query.material_id" class="mb-2">
                    <button @click.prevent="type = ''" type="button" class="btn mr-2"
                        :class="type == '' ? 'btn-primary' : 'btn-outline-primary'">
                        All
                    </button>
                    <button @click.prevent="type = 'in'" type="button" class="btn mr-2"
                        :class="type == 'in' ? 'btn-primary' : 'btn-outline-primary'">Masuk
                    </button>
                    <button @click.prevent="type = 'out'" type="button" class="btn mr-2"
                        :class="type == 'out' ? 'btn-primary' : 'btn-outline-primary'">Keluar
                    </button>
                </div>
            </template>
            <template v-slot:button-riwayat>
                <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex">
                        <button v-if="$route.query.material_id" v-can="'material/stock_movement/create'" type="button"
                            class="btn btn-sm btn-primary" data-toggle="modal" data-target="#modal-form-riwayat"
                            @click="resetModel(); formTitle = 'Tambah Masuk/Keluar'">
                            Tambah Keluar/Masuk
                        </button>
    
                        <!-- Filter Modal Button -->
                        <button v-if="!$route.query.material_id" type="button" class="btn btn-outline-primary btn-sm" style="margin-left: 4px;" data-toggle="modal"
                            data-target="#filterModal">
                            Filter
                        </button>
                        <!-- Filter Modal Button -->
    
                        <!-- Sort Dropdown -->
                        <div v-if="!$route.query.material_id" class="dropdown" style="margin-left: 4px;">
                            <button class="btn btn-outline-primary btn-sm" type="button" id="dropdownSortButton"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Sort by
                            </button>
                            <div class="dropdown-menu" style="min-width: 230px;" aria-labelledby="dropdownSortButton">
                                <a class="dropdown-item d-flex justify-content-between" href="#"
                                    @click.prevent="sortBy('created_at', 'desc')">
                                    Terbaru
                                    <span v-if="currentSort == 'created_at' && currentSortDir == 'desc'">✔</span>
                                </a>
                                <a class="dropdown-item d-flex justify-content-between" href="#"
                                    @click.prevent="sortBy('created_at', 'asc')">
                                    Terdahulu
                                    <span v-if="currentSort == 'created_at' && currentSortDir == 'asc'">✔</span>
                                </a>
                                <a class="dropdown-item d-flex justify-content-between" href="#"
                                    @click.prevent="sortBy('name', 'asc')">
                                    Nama Material A-Z
                                    <span v-if="currentSort == 'name' && currentSortDir == 'asc'">✔</span>
                                </a>
                                <a class="dropdown-item d-flex justify-content-between" href="#"
                                    @click.prevent="sortBy('name', 'desc')">
                                    Nama Material Z-A
                                    <span class="mr-2" v-if="currentSort == 'name' && currentSortDir == 'desc'">✔</span>
                                </a>
                            </div>
                        </div>
                        <!-- Sort Dropdown -->
                    </div>

                    <router-link to="/smartlog" class="btn btn-secondary btn-sm">Kembali</router-link>
                </div>


            </template>

            <template v-slot:search>
                <div class="input-group form-search-rounded">
                    <input class="form-control py-2 border-right-0 border" v-model="search" type="search"
                        id="example-search-input" placeholder="Cari">
                    <span class="input-group-append">
                        <div class="input-group-text bg-transparent">
                            <span class="text-blue"><i class="fa fa-search"></i></span>
                        </div>
                    </span>
                </div>
            </template>

            <template v-slot:columnHeader>
                <thead>
                    <tr>
                        <th>No.</th>
                        <th>Nama Material</th>
                        <th>Gudang</th>
                        <th @click="sortBy('date')">
                            Tanggal
                            <i class="fa sort"
                                :class="currentSort == 'date' ? currentSortDir == 'asc' ? 'fa-sort-down' : currentSortDir == 'desc' ? 'fa-sort-up' : 'fa-sort' : 'fa-sort'"></i>
                        </th>
                        <th>Type</th>
                        <th>Jumlah</th>
                        <th>Material Dari</th>
                        <th>Status</th>
                        <th>Yang Mengambil</th>
                        <th>Sisa Stok</th>
                        <th>Diupdate Oleh</th>
                        <th>Link Bukti</th>
                        <th width="10%">Aksi</th>
                    </tr>
                </thead>
            </template>

            <template v-slot:action="{ data }">
                <div class="btn-action-block">
                    <button v-if="!$route.query.material_id" v-can="'material/stock_movement/detail'" type="button"
                        class="btn btn-icon-small btn-success-trans waves-effect waves-light mr-2" data-toggle="modal"
                        data-target="#modal-detail-riwayat"
                        @click.prevent="detailMode(data); formTitle = 'Detail Masuk/Keluar'">
                        <i class="fa fa-eye"></i>
                    </button>
                    <button v-if="$route.query.material_id" v-can="'material/stock_movement/update'" type="button"
                        class="btn btn-icon-small btn-warning-trans waves-effect waves-light mr-2" data-toggle="modal"
                        data-target="#modal-form-riwayat"
                        @click.prevent="editMode(data); formTitle = 'Ubah Masuk/Keluar'">
                        <i class="fa fa-pencil"></i>
                    </button>
                    <button v-if="$route.query.material_id" v-can="'material/stock_movement/delete'" type="button"
                        @click="destroy(data)" class="btn btn-icon-small btn-danger-trans waves-effect waves-light"
                        id="confirm-text" style="margin-left: 2px;">
                        <i class="fa fa-trash"></i>
                    </button>
                </div>
            </template>
        </List>

        <!-- Modal Form -->
        <ModalB4 :title="formTitle" id="modal-form-riwayat">
            <Form ref="formStock" :material_id="$route.query.material_id" @deleted="getList" @saved="getList" />
        </ModalB4>

        <!-- Modal detail -->
        <ModalB4 title="Detail Masuk/Keluar" id="modal-detail-riwayat">
            <Detail ref="detailStock" />
            <template #footer>
                <div class="d-flex justify-content-end">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Tutup</button>
                </div>
            </template>
        </ModalB4>

        <!-- Filter Modal -->
        <ModalB4 title="Filter" id="filterModal">
            <div class="row">
                <div class="col-6">
                    <div class="form-group">
                        <label for="">Sub Kategori</label>
                        <multiselect v-model="selectedSubCategories" :options="sub_categories"
                            :multiple="true" placeholder="Select" selected-label="✔" select-label="✔"
                            deselect-label="✖" label="name" track-by="id" :close-on-select="false"
                            @input="filters.sub_category_ids = selectedSubCategories.map(item => item.id)">
                            <!-- Slot untuk mengganti tampilan yang muncul di input -->
                            <template #selection="{ values }">
                                <span v-if="values.length > 0" class="multiselect__single">
                                    {{ values.length }} selected
                                </span>
                            </template>
                        </multiselect>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label for="">UPP</label>
                        <multiselect v-model="selectedUnits" :options="units" :multiple="true"
                            placeholder="Select" select-label="✔" deselect-label="✖" label="name"
                            track-by="id" :close-on-select="false"
                            @input="filters.unit_ids = selectedUnits.map(item => item.id)">
                            <!-- Slot untuk mengganti tampilan yang muncul di input -->
                            <template #selection="{ values }">
                                <span v-if="values.length > 0" class="multiselect__single">
                                    {{ values.length }} selected
                                </span>
                            </template>
                        </multiselect>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label for="formSelectGuadang">Gudang</label>
                        <multiselect v-model="selectedWarehouses" :options="gudangs" :multiple="true"
                            placeholder="Select" select-label="✔" deselect-label="✖" label="name"
                            track-by="id" :close-on-select="false"
                            @input="filters.warehouse_ids = selectedWarehouses.map(item => item.id)">
                            <!-- Slot untuk mengganti tampilan yang muncul di input -->
                            <template #selection="{ values }">
                                <span v-if="values.length > 0" class="multiselect__single">
                                    {{ values.length }} selected
                                </span>
                            </template>
                        </multiselect>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label for="formSelectKategoriMaterial">Kategori Material</label>
                        <multiselect v-model="filters.material_categories"
                            :options="['PDP', 'Non PDP', 'ATTB']" :multiple="true" placeholder="Select"
                            select-label="✔" deselect-label="✖" :close-on-select="false">
                            <!-- Slot untuk mengganti tampilan yang muncul di input -->
                            <template #selection="{ values }">
                                <span v-if="values.length > 0" class="multiselect__single">
                                    {{ values.length }} selected
                                </span>
                            </template>
                        </multiselect>
                    </div>
                </div>
            </div>
            <template #footer>
                <div class="d-flex justify-content-end">
                    <button type="button" data-dismiss="modal" class="btn btn-outline-primary mr-1"
                        @click="resetFilters">Reset</button>
                    <button type="button" data-dismiss="modal" class="btn btn-primary"
                        @click.prevent="getList">Simpan</button>
                </div>
            </template>
        </ModalB4>
        <!-- Filter Modal -->
    </section>
</template>

<script>
import List from '@/components/List.vue'
import Form from './Form.vue'
import Detail from './Detail.vue'
import ModalB4 from '@/components/ModalB4.vue'

export default {
    components: {
        List, Form, Detail, ModalB4
    },
    data() {
        return {
            table: {
                title: "Riwayat Masuk Keluar",
                breadcumb: {
                    name: "SmartLog",
                    url: '/smartlog',
                },
                dataTable: {
                    lists: [],
                    columns: [
                        'material.name',
                        'material.storage.warehouse.name',
                        'date',
                        'type_text',
                        'qty',
                        'from',
                        'request_type',
                        'to',
                        'remaining_stock',
                        'updated_by_user.name',
                        'attachments'
                    ]
                }
            },
            formTitle: 'Tambah Masuk/Keluar',
            search: null,
            currentSort: 'id',
            currentSortDir: 'desc',
            type: '',
            selectedUnits: [],
            selectedSubCategories: [],
            selectedWarehouses: [],
            materials: [],
            gudangs: [],
            sub_categories: [],
            categories: [],
            units: [],
            filters: {
                sub_category_ids: [],
                warehouse_ids: [],
                unit_ids: [],
                material_categories: [],
            },
            category: null,
        }
    },
    mounted() {
        let _ = this
        _.getList()
        if(!this.$route.query.material_id){
            _.getUnit()
            _.getGudang()
            _.getSubCategory()
            // _.getCategory()
        }
        _.$root.$on("paginate", (data) => {
            _.getList(data)
        })
        window.$('#modal-form-riwayat').on('hide.bs.modal', function () {
            document.activeElement.blur(); // buang fokus
        });
    },
    beforeDestroy() {
        this.$root.$off("paginate");
        window.$('[data-toggle="tooltip"]').tooltip();
    },
    beforeCreate() {
        window.$('[data-toggle="tooltip"]').tooltip('dispose');
    },
    methods: {
        // filter functions
        resetFilters() {
            this.selectedSubCategories = [];
            this.selectedUnits = [];
            this.selectedWarehouses = [];
            this.filters = {
                sub_category_ids: [],
                warehouse_ids: [],
                unit_ids: [],
                material_categories: [],
            };
            this.getList();
        },
        getGudang() {
            let _ = this
            _.axios.get('/warehouses?unit_ids=')
                .then(resp => {
                    _.gudangs = resp.data.data
                })
                .catch(err => {
                    console.log(err.response)
                })
        },
        selectCategory(id) {
            let _ = this
            _.tab_category = id
            _.getSubCategory()
        },
        getSubCategory() {
            let _ = this
            _.axios.get('/categories', {
                params: {
                    parent_id: _.category,
                }
            })
                .then(resp => {
                    let all_category = resp.data.data
                    _.sub_categories = all_category.filter(item => item.parent_id !== 0);
                })
                .catch(err => {
                    console.log(err.response)
                })
        },
        getCategory() {
            let _ = this
            _.axios.get('/categories?parent_id=0')
                .then(resp => {
                    _.categories = resp.data.data
                })
                .catch(err => {
                    console.log(err.response)
                })
        },
        getUnit() {
            let _ = this
            _.axios.get('/unit', {
                params: {
                    only_allowed_units: 1,
                }
            })
                .then(resp => {
                    _.units = resp.data.data.data
                })
                .catch(err => {
                    console.log("gagal", err.response)
                })
        },
        // main functions
        getList(page) {
            let _ = this
            _.axios.get('/material-stock-movements', {
                params: {
                    search: _.search,
                    page: page,
                    sort: _.currentSortDir,
                    orderby: _.currentSort,
                    type: _.type,
                    material_id: _.$route.query.material_id,
                    ..._.filters
                }
            })
                .then(resp => {
                    _.table.dataTable.lists = resp.data.data
                })
                .catch(err => {
                    console.log(err.response);
                })
        },
        resetModel() {
            this.$refs.formStock.resetModel()
        },
        editMode(item) {
            this.$refs.formStock.editMode(item)
        },
        detailMode(item) {
            this.$refs.detailStock.loadDetail(item)
        },
        destroy(x) {
            this.$refs.formStock.destroy(x)
        },
        sortBy(orderBy, sortDir) {
            this.currentSort = orderBy;
            this.currentSortDir = sortDir;
            this.getList()
        }
    },
    watch: {
        search: function () {
            this.getList()
        },
        type: function () {
            this.getList()
        },
    }
}
</script>